'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'face-glasses';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e377';
var svgPathData = ['M0 256c0-27.9 4.5-54.8 12.7-80l19.3 0 0 112 208 0 0-112 32 0 0 112 208 0 0-112 19.3 0c8.3 25.2 12.7 52.1 12.7 80 0 25-3.6 49.2-10.3 72L485 328c-30.6 97.4-121.5 168-229 168S57.6 425.4 27 328l-16.7 0C3.6 305.2 0 281 0 256zM44.3 112C54.2 97.5 65.5 84.1 78 72l23.9 0C143.6 37 197.3 16 256 16S368.4 37 410.1 72L434 72c12.5 12.1 23.8 25.5 33.7 40l-195.7 0 0 48-32 0 0-48-195.7 0zM133 353.3c27.6 38 72.4 62.7 123 62.7s95.4-24.7 123-62.7l-12.9-9.4C341.4 377.9 301.3 400 256 400s-85.4-22.1-110.1-56.1L133 353.3z', 'M485 328c-30.6 97.4-121.5 168-229 168S57.6 425.4 27 328l-16.7 0C41.4 434.3 139.6 512 256 512s214.6-77.7 245.7-184L485 328zM256 16c58.7 0 112.4 21 154.1 56L434 72C387.9 27.4 325.2 0 256 0S124.1 27.4 78 72l23.9 0C143.6 37 197.3 16 256 16zm0 384c-45.3 0-85.4-22.1-110.1-56.1L133 353.3c27.6 38 72.4 62.7 123 62.7s95.4-24.7 123-62.7l-12.9-9.4C341.4 377.9 301.3 400 256 400zm16-288l0 48-32 0 0-48-208 0 0 48-32 0 0 16 32 0 0 112 208 0 0-112 32 0 0 112 208 0 0-112 32 0 0-16-32 0 0-48-208 0zm192 64l0 96-176 0 0-144 176 0 0 48zM224 160l0 112-176 0 0-144 176 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceGlasses = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;